import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import { getTeamsQuery, getMyUserQuery } from '../../../queries/queries';
import { LoadingTable, TableSection, EditButton, sortList } from '../../../common/index';
import Form from './TeamsForm';
import ModalAddTeam from './ModalAddTeam';
import Team from './Team';
import ArrowBlack from '../../../img/arrow-black.svg'


function TeamsTable(props) {
  const { associationId, associationData, period } = props;
  const [editing, setEditing] = useState('');
  const [sortBy, setSortBy] = useState('name');
  const [sortOrder, setSortOrder] = useState(1);
  const sort = { sortBy, sortOrder, setSortBy, setSortOrder };
  const [isFirstTeam, setIsFirstTeam] = React.useState()
  const { data: userData } = useQuery(getMyUserQuery)
  const { data: teamsQuery, loading, error, refetch } = useQuery(getTeamsQuery, {
    variables: { associationId }
  });

  React.useEffect(() => {
    teamsQuery?.teams && console.log('Lag', teamsQuery.teams);
    setIsFirstTeam(teamsQuery?.teams?.length === 0)
  }, [teamsQuery?.teams])

  return (
    <>
      {editing === 'new' &&
        <ModalAddTeam
          associationId={associationId}
          isFirstTeam={isFirstTeam}
          setIsFirstTeam={setIsFirstTeam}
          setEditing={setEditing}
          refetchTeam={refetch}
        />
      }
      {teamsQuery?.teams?.length > 0
        ? <table className='teams-table'>
          <thead className='relative'>
            <tr>
              <td>Lag/Lagledare</td>
            </tr>
          </thead>
          <tbody>
            {!teamsQuery?.teams ? <LoadingTable loading={loading} error={error} /> : (
              sortList(teamsQuery?.teams, sort).map((obj) => (
                editing === obj._id
                  ? <Form key={obj._id} content={obj} associationData={associationData} onComplete={() => setEditing('')} teamEdit />
                  : <Team key={obj._id} user={userData?.user} team={obj} associationId={associationId} setEditing={setEditing} period={period} />
              )))}
            <tr>
              <td></td>
              <td>
                <EditButton size="md" setEditing={() => setEditing('new')}>Lägg till lag</EditButton>
              </td>
            </tr>
          </tbody>

        </table>
        : teamsQuery?.teams &&
        <div className='table-empty'>
          <p>Klicka på 'Lägg till lag' för att lägga till ditt första lag.</p>
          <img src={ArrowBlack} alt="" />
          <EditButton size="md" setEditing={() => setEditing('new')}>Lägg till lag</EditButton>
        </div>
      }
      <p className='text-center'>
        Det du döper laget till är även det som deras webbshop kommer att heta.
      </p>
    </>
  );
}

TeamsTable.propTypes = {
  associationId: PropTypes.string.isRequired,
};

export default TeamsTable;
